import Inventories from "../../services/api/Inventories";
import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import qs from "qs";
import Errors from "../../constants/Errors.json";

const handleError = (err) => {
  console.log("[handleError] Error in Inventories actions", err);
};

export const setInventoriesList = (payload) => {
  return {
    type: ActionTypes.SET_INVENTORIES_LIST,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_INVENTORIES,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_INVENTORIES,
    payload,
  };
};

export const getInventoriesList =
  (filters = {}, mappingFilters) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...filters,
      };
      if (filters["start_time"]) {
        finalPayload["start_time"] = filters["start_time"] + "T00:00:00Z";
      }
      const queryParamsString = qs.stringify(finalPayload, {
        addQueryPrefix: true,
        encode: false,
      });
      dispatch(setLoader(true));
      let response = await Inventories.getInventoriesList(queryParamsString);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setInventoriesList(response));
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
